import * as d3 from 'd3'
export default {
  methods: {

    child_InputList(stg, data) {

      let parent = this.config.parent
      let child = this.config.child
      let y_ = data.length > 0 ? -(data.length * child.lineHeignt)+10 : 0

      let inOut = this.canvasForms
      .append('g')
      .attr('id', `INPUT_LIST_${stg.IDX}`)
      .attr('transform', `translate(${this.config.x[stg.IDX]}, ${this.config.y})`)

      if(data.length > 0) {
        this.gmx_Line(inOut, -10, -10, y_, (parent.height/4), '#bcbcbc', .5, 1)
        this.gmx_Line(inOut, -10, 0, (parent.height/4), (parent.height/4), '#bcbcbc', .5, 1)
      }

      data.forEach((d,i)=> {
        this.gmx_Line(inOut, -10, -20, y_+1, y_+1, '#bcbcbc', .5, 1)

        let item = inOut
        .append('g')
        .attr('transform', `translate(-20, 0)`)

        item
        .append('circle')
        .attr('cx', 0).attr('cy', y_+1).attr('r', 2.5).attr('fill', '#bcbcbc')
        
        item
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/icon/DB_${d.TYPE}.svg`).attr('x', -25).attr('y', y_-8).attr('height', 17)

        item
        .append('text')
        .attr('x', -30).attr('y', y_  + parent.tSize*0.36)
        .attr('fill', child.tColor).attr('font-size', child.tSize).attr('text-anchor', 'end')
        .text(d.TYPE == 'Excel' ? `${d.NAME}` : `${d.SCHEMA}.${d.NAME}`)

        y_ += child.lineHeignt
      })
    },



    child_ExecList(stg, data) {
      
      let parent = this.config.parent
      let child = this.config.child
      let y_ = 20

      let exec = this.canvasForms
      .append('g')
      .attr('id', `EXECUTION_LIST_${stg.IDX}`)
      .attr('transform', `translate(${this.config.x[stg.IDX]}, ${this.config.y + parent.height})`)
      
      data.forEach(d=> {

        let item = exec
        .append('g')
        .attr('transform', `translate(0, 0)`)

        item
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/icon/DB_Procedure.svg`).attr('x', 0).attr('y', y_-6).attr('height', 13)

        item
        .append('text')
        .attr('x', 20).attr('y', y_  + parent.tSize*0.36)
        .attr('fill', '#44A9DF')
        .attr('font-size', child.tSize)
        .text(`${d.SCHEMA}.${d.NAME}`)

        y_ += child.lineHeignt
      })

    },



    child_OutputList(stg, data) {

      let parent = this.config.parent
      let child = this.config.child

      let inOut = this.canvasForms
      .append('g')
      .attr('id', `OUTPUT_LIST_${stg.IDX}`)
      .attr('transform', `translate(${this.config.x[stg.IDX] + this.getNode(`#STAGE_BOX_${stg.IDX}`)}, ${this.config.y})`)

      if(data.length > 0) {
        this.gmx_Line(inOut, 0, 10, (parent.height - (parent.height/4)), (parent.height - (parent.height/4)), '#bcbcbc', .5, 1)
      }

      let y_ = parent.height + 20
      data.forEach(d=> {
        this.gmx_Line(inOut, 10, 20, y_+1, y_+1, '#bcbcbc', .5, 1)

        let item = inOut
        .append('g')
        .attr('transform', `translate(10, 0)`)

        item
        .append('circle')
        .attr('cx', 10).attr('cy', y_+1).attr('r', 3).attr('fill', '#bcbcbc')

        item
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/icon/DB_${d.TYPE}.svg`).attr('x', 18).attr('y', y_-8).attr('height', 17)

        item
        .append('text')
        .attr('x', 40).attr('y', y_  + parent.tSize*0.36)
        .attr('fill', stg.IDX ==this.stages.length-1 ? '#000' : child.tColor)
        .attr('font-size', stg.IDX ==this.stages.length-1 ? child.tSize + 1 : child.tSize)
        .text(`${d.SCHEMA}.${d.NAME}`)

        y_ += child.lineHeignt
      })
      this.gmx_Line(inOut, 10, 10, parent.height - (parent.height/4), y_-child.lineHeignt+1, '#bcbcbc', .5, 1)
    },

  }
}